import { Injectable, signal } from '@angular/core';
import { AppSettings, defaults } from 'src/app/config';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  readonly optionsSignal = signal<AppSettings>(defaults);

  constructor() {
    // 🧙 On service boot: hydrate the settings
    const savedTheme = localStorage.getItem('theme');

    const savedSettings: Partial<AppSettings> = {};

    if (savedTheme) {
      savedSettings.theme = savedTheme;
    }

    // Merge saved settings into signal
    this.setOptions(savedSettings);
  }

  getOptions() {
    return this.optionsSignal();
  }

  setOptions(options: Partial<AppSettings>) {
    this.optionsSignal.update((current) => {
      const updated = { ...current, ...options };

      if (options.theme) {
        localStorage.setItem('theme', options.theme);
      }
      return updated;
    });
  }

  setLanguage(lang: string) {
    this.setOptions({ language: lang });
  }

  getLanguage() {
    return this.getOptions().language;
  }
}
